import React, { useCallback } from 'react';
import IconFont from '$/components/IconFont';
import styles from './index.module.scss';

export interface TeamSeatSelectorProps {
  value: number;
  min?: number;
  max?: number;
  seatText: React.ReactNode;
  totalLabel: React.ReactNode;
  totalText: React.ReactNode;
  variant?: 'card' | 'order';
  className?: string;
  decreaseLabel?: string;
  increaseLabel?: string;
  onChange: (value: number) => void;
}

/** 渲染团队席位步进器与实时合计，供套餐卡和订单确认弹窗复用。 */
function TeamSeatSelector({
  value,
  min = 1,
  max = Number.MAX_SAFE_INTEGER,
  seatText,
  totalLabel,
  totalText,
  variant = 'card',
  className,
  decreaseLabel = '减少席位',
  increaseLabel = '增加席位',
  onChange,
}: TeamSeatSelectorProps) {
  /** 在席位下限内减少一个席位。 */
  const handleDecrease = useCallback(() => {
    onChange(Math.max(min, value - 1));
  }, [min, onChange, value]);

  /** 在席位上限内增加一个席位。 */
  const handleIncrease = useCallback(() => {
    onChange(Math.min(max, value + 1));
  }, [max, onChange, value]);

  return (
    <div className={[styles.row, styles[variant], className].filter(Boolean).join(' ')}>
      <div className={styles.stepper}>
        <button
          type="button"
          aria-label={decreaseLabel}
          disabled={value <= min}
          onClick={handleDecrease}
        >
          <IconFont name="minusBlack" fontSize={16} color="currentColor" />
        </button>
        <span>{seatText}</span>
        <button
          type="button"
          aria-label={increaseLabel}
          disabled={value >= max}
          onClick={handleIncrease}
        >
          <IconFont name="plusBlack" fontSize={16} color="currentColor" />
        </button>
      </div>

      <div className={styles.total}>
        <span>{totalLabel}</span>
        <strong>{totalText}</strong>
      </div>
    </div>
  );
}

export default TeamSeatSelector;
